import type { ReactNode } from 'react'
import { cx } from 'utils/cx'

import styles from './Divider.module.scss'

interface CountdownProps {
	readonly variant?: 'default' | 'subtle' | 'inverse'
	readonly title?: string
}

export function Divider({
	variant = 'default',
	title,
}: CountdownProps): ReactNode {
	return (
		<div className={styles.container}>
			<hr className={cx(styles.divider, styles[variant])} />
			{title && <p className={styles.title}>{title}</p>}
		</div>
	)
}
